export default __webpack_public_path__ + "static/media/0 a.d1ce2222.png";